import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';

const SingleIncomeDetails = () => {
  const { incomeId } = useParams();
  const decodedId = incomeId ? atob(incomeId) : incomeId;
  const id = decodedId.replace(/\D/g, ''); // Ensure we only get the numeric part
  const [incomeDetails, setIncomeDetails] = useState(null);

  const [columns, setColumnDetails] = useState([]);

  useEffect(() => {
    const fetchIncomeDetails = async () => {
      try {
        const response = await axios.get(`${API_DOMAIN}${API_ROUTES.income}${id}/`, { headers });
        const extractedColumns = Object.keys(response.data);

        // Define which columns to exclude (if necessary)
        const excludedColumns = ['id', 'created_at', 'updated_at'];
        const columnsArray = extractedColumns
          .filter((column) => !excludedColumns.includes(column))
          .map((column) => ({
            label: column.charAt(0).toUpperCase() + column.slice(1).replace('_', ' '),
            field: column,
          }));

        setColumnDetails(columnsArray);
        setIncomeDetails(response.data);
      } catch (error) {
        console.error('Error fetching income details:', error);
      }
    };

    fetchIncomeDetails();
  }, [incomeId]);

  return (
    <div>
      {incomeDetails ? (
        <SingleItemDetailTemplate details={incomeDetails} columns={columns} />
      ) : (
        <p>Loading income details...</p>
      )}
    </div>
  );
};

export default SingleIncomeDetails;